import React from 'react';
import ReactSVG from "react-svg";

const AppLoading = () => {
  return <div className="app app-content-container app--loading">
    <div className="loadingPage">
      <ReactSVG src="/classpath/assets/images/svg/loading-circles.svg" className="loadingPage__svg" />
    </div>
  </div>;
};

export default AppLoading;